export enum PosSystemNames {
  Clover = "clover",
  Cova = "cova",
  Surge = "surge",
  Pax = "pax"
}

export class POSSystemInfo {
  public id: number;
  public name: string;
  public code: string;
  public configuration: PosSystemConfigurationDto;
}

export enum ReceiptPromotionDestinationType {
  Widget = "Widget",
  Coupon = "Coupon",
  CustomUrl = "CustomUrl"
}

export interface PosSystemReceiptPromotionConfigurationDto {
  destinationType: ReceiptPromotionDestinationType;
  widgetId?: number;
  couponId?: string;
}

export enum ThankYouPageDestinationType {
  Widget = "Widget",
  Coupon = "Coupon",
  CustomUrl = "CustomUrl"
}

export interface PosSystemThankYouPageConfigurationDto {
  destinationType: ThankYouPageDestinationType;
  widgetId?: number | null;
  couponId?: string | null;
  updatedOnUtc?: string;
}

export class PosSystemConfigurationDto {
  public feature: PosSystemFeatureConfigurationDto;
}

export class PosSystemFeatureConfigurationDto {
  public isProductsImportEnabled: boolean;
  public isDeliveryChannelsVisible: boolean;
}
